import React from 'react';

import Spinner from '#@/components/Spinner';

import StyledPageLoader from './Styles';

const PageLoader: React.FC = () => (
  <StyledPageLoader data-cy-page-loader>
    <Spinner size={70} />
  </StyledPageLoader>
);

export default PageLoader;
